import angular from 'angular';
import uiRouter from 'angular-ui-router';
import stBrowserAlertsComponent from './stBrowserAlerts.component';

let stBrowserAlertsModule = angular.module('stBrowserAlerts', [
  uiRouter
])

.component('stBrowserAlerts', stBrowserAlertsComponent)
.name;

export default stBrowserAlertsModule;



// WEBPACK FOOTER //
// ./client/app/common/stBrowserAlerts/stBrowserAlerts.js